export enum DocumentType {
  "Training" = "10",
  "Testing" = "20",
  "Prediction" = "30",
}
